"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
function getInitialChangesValue(propsToTrack) {
    return lodash_1.reduce(propsToTrack, (result, value, key) => {
        result[key] = {
            initialValue: value,
            currentValue: value,
            wasChanged: false,
        };
        return result;
    }, {});
}
/**
  Tracks changes made to props passed to a component. When the component unmounts
  (or when you change the `onTrackChanges` callback), the `onTrackChanges` callback
  will be called with a set of changes objects describing what changed:

  ```
    {
      firstName: {
        initialValue: 'mary',
        currentValue: 'sally',
        wasChanged: true,
      },
      lastName: {
        initialValue: 'smith',
        currentValue: 'smith',
        wasChanged: smith,
      }
    }
  ```

  The `wasChanged` prop helps distinguish when a prop was changed but then changed
  back to its original value. In that case `initialValue` and `currentValue` will be
  the same, but `wasChanged` will be `true`.
*/
function useTrackPropChanges({ onTrackChanges, propsToTrack, }) {
    const changesRef = react_1.useRef(getInitialChangesValue(propsToTrack));
    react_1.useEffect(() => {
        lodash_1.each(propsToTrack, (value, key) => {
            const change = changesRef.current[key];
            if (change.currentValue !== value) {
                changesRef.current[key] = {
                    initialValue: change.initialValue,
                    currentValue: value,
                    wasChanged: true,
                };
            }
        });
    }, [propsToTrack]);
    react_1.useEffect(() => () => onTrackChanges(changesRef.current), [onTrackChanges]);
}
exports.default = useTrackPropChanges;
